import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { AppProvider } from './context/AppContext';
import { ApiProvider } from './context/ApiContext';
import { AptMetrixProvider } from './context/AptMetrixContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <ApiProvider>
        <AptMetrixProvider>
          <App />
        </AptMetrixProvider>
      </ApiProvider>
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
